export default {
  id: "dropdown",
  name: "Dropdown",
  settings: {
    enableMultipleSelect: true
  }
};
